

export const Action_GetDMGiaCong = "Action_GetDMGiaCong";
export const Action_GetDMGiaCongSuccess = "Action_GetDMGiaCongSuccess";

export const Action_GetGiaCongByNhomSanPham = "Action_GetGiaCongByNhomSanPham";
export const Action_GetGiaCongByNhomSanPhamSuccess = "Action_GetGiaCongByNhomSanPhamSuccess";

export const Action_SaveGiaCongByNhomSanPham = "Action_SaveGiaCongByNhomSanPham";
export const Action_SaveGiaCongByNhomSanPhamSuccess = "Action_SaveGiaCongByNhomSanPhamSuccess";
export const Action_SaveGiaCongByNhomSanPhamFailed = "Action_SaveGiaCongByNhomSanPhamFailed";

export const Action_DeleteGiaCongByNhomSanPham = "Action_DeleteGiaCongByNhomSanPham";
export const Action_DeleteGiaCongByNhomSanPhamSuccess = "Action_DeleteGiaCongByNhomSanPhamSuccess";
export const Action_DeleteGiaCongByNhomSanPhamFailed = "Action_DeleteGiaCongByNhomSanPhamFailed";







